import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import { queryExamine, queryNoticeCate, addAppendAudit } from '@/api/notice/noticeApi.js';
export default {
  data: function data() {
    var columns = [{
      title: '紧急状态',
      dataIndex: 'emergency',
      align: 'center',
      width: 80,
      scopedSlots: {
        customRender: 'emergency'
      }
    }, {
      title: '公告分类',
      dataIndex: 'cateName',
      align: 'center',
      width: 100
    }, {
      title: '公告标题',
      dataIndex: 'title',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '拟稿人',
      dataIndex: 'drafterTemp',
      align: 'center',
      width: 180,
      scopedSlots: {
        customRender: 'drafterTemp'
      }
    }, {
      title: '拟稿时间',
      dataIndex: 'createTime',
      ellipsis: true,
      align: 'center',
      width: 100
    }, {
      title: '当前环节',
      dataIndex: 'appendName',
      align: 'center',
      width: 120
    },
    // {
    //     title: '当前环节',
    //     dataIndex: 'currAuditNode',
    //     align: 'center',
    //     width: 180,
    //     scopedSlots: { customRender: 'currAuditNode' }
    // },
    {
      title: '发布范围',
      dataIndex: 'range',
      ellipsis: true,
      align: 'center',
      width: 100,
      customRender: function customRender(range) {
        if (0 === range) {
          return '全校教职工';
        } else if (1 === range) {
          return '自定义';
        } else if (2 === range) {
          return '当前组织层级';
        } else if (3 === range) {
          return '当前组织层级指定人员';
        } else {
          return '';
        }
      }
    }, {
      title: '审核状态',
      dataIndex: 'auditStatus',
      align: 'center',
      width: 80,
      scopedSlots: {
        customRender: 'auditStatus'
      }
    }, {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      width: 100,
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      columns: columns,
      loading: false,
      expand: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      cateList: [],
      where: {
        cateId: '',
        auditStatus: '',
        query: '',
        emergency: ''
      },
      data: [],
      pagination: this.$hdk.page()
    };
  },
  created: function created() {
    var fetch = this.fetch,
      getNoticeCate = this.getNoticeCate;
    fetch();
    getNoticeCate();
  },
  methods: {
    /*
     * 根据条件搜索通知公告
     */
    fetch: function fetch(options) {
      var _this = this;
      var pagination = this.pagination,
        where = this.where,
        pager = _.assign({}, pagination, options);
      this.loading = true;
      if (!pager.where) {
        pager.where = where;
      }
      queryExamine(pager.current, pager.pageSize, pager.where).then(function (res) {
        _this.data = res.data.data;
        _.assign(pagination, {
          total: res.data.count,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(where, pager.where);
      }).finally(function () {
        _this.loading = false;
      });
    },
    /*
     * 表格改变事件
     */
    onChange: function onChange(pagination) {
      this.fetch({
        current: pagination.current,
        pageSize: pagination.pageSize,
        where: this.where
      });
    },
    /*
     * 公告分类
     */
    getNoticeCate: function getNoticeCate() {
      var _this2 = this;
      queryNoticeCate().then(function (res) {
        _this2.cateList = res.data.data;
      });
    },
    /*
     * 是否打开折叠搜索界面
     */
    toggle: function toggle() {
      this.expand = !this.expand;
    },
    /**
     * 打开查看
     */
    view: function view(row) {
      this.$router.push({
        path: '/docNotice/notice/auditNotice',
        query: {
          id: row.id,
          type: 1
        }
      });
    },
    /**
     * 打开审核
     */
    audit: function audit(row) {
      this.$router.push({
        path: '/docNotice/notice/auditNotice',
        query: {
          id: row.id,
          type: 2
        }
      });
    }
  }
};